__turbopack_context__.v({
  "mapEmbedding": "ToT2Bq_mapEmbedding",
});
